// Shared helper for linking a property address out to Google Maps.
// Used wherever a deal address renders so RMs/PMs/Chad can tap to navigate.

export type MapsAddressInput = {
  property_street?: string | null;
  property_city?: string | null;
  property_state?: string | null;
  property_zip?: string | null;
};

export function mapsHref(d: MapsAddressInput): string {
  const q = encodeURIComponent(
    [
      d.property_street,
      [d.property_city, d.property_state].filter(Boolean).join(", "),
      d.property_zip,
    ]
      .filter(Boolean)
      .join(" ")
  );
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
}

// Closed/terminal stages — the homeowner relationship is over, no reason to
// drive to the property anymore. Address renders as plain text on these.
const CLOSED_STAGES = new Set(["closed_won", "closed_lost", "cancelled"]);

export function isClosedStage(stage: string | null | undefined): boolean {
  return !!stage && CLOSED_STAGES.has(stage);
}

// True when the address should render as a tappable Maps link:
// - has a street to link to
// - deal isn't closed
export function isAddressLinkable(d: MapsAddressInput & { stage?: string | null }): boolean {
  return !!d.property_street && !isClosedStage(d.stage);
}
